import Pt, { createContext as it, useContext as Rt, useState as Qe, useEffect as Ee, useMemo as ot, forwardRef as ie } from "react";
import { gql as Ve, useMutation as Rr, useQuery as St, useApolloClient as Be } from "@apollo/client";
import Sr from "axios";
import { jsx as _, jsxs as V } from "react/jsx-runtime";
import "@mui/material/styles";
import { Tooltip as Ir, TextField as Or, InputAdornment as Nr, IconButton as It, Typography as Xe, FormLabel as Ar, Divider as Zr } from "@mui/material";
import { useTranslation as Ce } from "react-i18next";
const Dr = Sr.create(), Mr = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, $r = () => {
  const t = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return Mr[t];
}, Lr = {
  appDataStorageKey: "mage-cache-storage"
}, Ur = "en", Ot = ENVIRONMENT_REGION ?? "US", xt = "private-content-loaded";
function Vr(t, e) {
  return Dr(`/${t}`, {
    ...e,
    baseURL: "",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept-Language": $r() || Ur,
      ...e?.headers
    }
  });
}
const Br = ({
  element: t,
  identifier: e,
  prefix: r
}) => ({
  "data-selector": `${r ? `${r}-` : ""}${t}`,
  ...e && { id: `${t}-${e}` }
});
function zr(t) {
  const e = it(t), r = () => {
    const n = Rt(e);
    if (n === void 0)
      throw new Error(
        "Context is attempting to be consumed outside of its provider."
      );
    return n;
  };
  return {
    Provider: e.Provider,
    useContext: r
  };
}
var Oe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var de = { exports: {} };
de.exports;
var wt;
function qr() {
  return wt || (wt = 1, function(t, e) {
    var r = 9007199254740991, n = "[object Arguments]", s = "[object Function]", a = "[object GeneratorFunction]", i = "[object Map]", o = "[object Object]", c = "[object Promise]", u = "[object Set]", h = "[object WeakMap]", T = "[object DataView]", Re = /[\\^$.*+?()[\]{}|]/g, oe = /^\[object .+?Constructor\]$/, tr = typeof Oe == "object" && Oe && Oe.Object === Object && Oe, rr = typeof self == "object" && self && self.Object === Object && self, K = tr || rr || Function("return this")(), lt = e && !e.nodeType && e, ft = lt && !0 && t && !t.nodeType && t, nr = ft && ft.exports === lt;
    function sr(l, w) {
      return l?.[w];
    }
    function ar(l) {
      var w = !1;
      if (l != null && typeof l.toString != "function")
        try {
          w = !!(l + "");
        } catch {
        }
      return w;
    }
    function ir(l, w) {
      return function(S) {
        return l(w(S));
      };
    }
    var or = Function.prototype, Se = Object.prototype, Fe = K["__core-js_shared__"], pt = function() {
      var l = /[^.]+$/.exec(Fe && Fe.keys && Fe.keys.IE_PROTO || "");
      return l ? "Symbol(src)_1." + l : "";
    }(), ht = or.toString, qe = Se.hasOwnProperty, Ie = Se.toString, cr = RegExp(
      "^" + ht.call(qe).replace(Re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), mt = nr ? K.Buffer : void 0, gt = Se.propertyIsEnumerable, dr = mt ? mt.isBuffer : void 0, ur = ir(Object.keys, Object), Ke = ce(K, "DataView"), We = ce(K, "Map"), Ye = ce(K, "Promise"), He = ce(K, "Set"), Ge = ce(K, "WeakMap"), lr = !gt.call({ valueOf: 1 }, "valueOf"), fr = Y(Ke), pr = Y(We), hr = Y(Ye), mr = Y(He), gr = Y(Ge);
    function yr(l) {
      return Ie.call(l);
    }
    function vr(l) {
      if (!_t(l) || _r(l))
        return !1;
      var w = vt(l) || ar(l) ? cr : oe;
      return w.test(Y(l));
    }
    function ce(l, w) {
      var S = sr(l, w);
      return vr(S) ? S : void 0;
    }
    var W = yr;
    (Ke && W(new Ke(new ArrayBuffer(1))) != T || We && W(new We()) != i || Ye && W(Ye.resolve()) != c || He && W(new He()) != u || Ge && W(new Ge()) != h) && (W = function(l) {
      var w = Ie.call(l), S = w == o ? l.constructor : void 0, bt = S ? Y(S) : void 0;
      if (bt)
        switch (bt) {
          case fr:
            return T;
          case pr:
            return i;
          case hr:
            return c;
          case mr:
            return u;
          case gr:
            return h;
        }
      return w;
    });
    function _r(l) {
      return !!pt && pt in l;
    }
    function br(l) {
      var w = l && l.constructor, S = typeof w == "function" && w.prototype || Se;
      return l === S;
    }
    function Y(l) {
      if (l != null) {
        try {
          return ht.call(l);
        } catch {
        }
        try {
          return l + "";
        } catch {
        }
      }
      return "";
    }
    function xr(l) {
      return kr(l) && qe.call(l, "callee") && (!gt.call(l, "callee") || Ie.call(l) == n);
    }
    var wr = Array.isArray;
    function yt(l) {
      return l != null && Er(l.length) && !vt(l);
    }
    function kr(l) {
      return Cr(l) && yt(l);
    }
    var jr = dr || Pr;
    function Tr(l) {
      if (yt(l) && (wr(l) || typeof l == "string" || typeof l.splice == "function" || jr(l) || xr(l)))
        return !l.length;
      var w = W(l);
      if (w == i || w == u)
        return !l.size;
      if (lr || br(l))
        return !ur(l).length;
      for (var S in l)
        if (qe.call(l, S))
          return !1;
      return !0;
    }
    function vt(l) {
      var w = _t(l) ? Ie.call(l) : "";
      return w == s || w == a;
    }
    function Er(l) {
      return typeof l == "number" && l > -1 && l % 1 == 0 && l <= r;
    }
    function _t(l) {
      var w = typeof l;
      return !!l && (w == "object" || w == "function");
    }
    function Cr(l) {
      return !!l && typeof l == "object";
    }
    function Pr() {
      return !1;
    }
    t.exports = Tr;
  }(de, de.exports)), de.exports;
}
var Kr = qr();
const Wr = /* @__PURE__ */ Fr(Kr);
function kt(t) {
  return Wr(t);
}
const Yr = (t, e) => window.localStorage.setItem(t, e), Hr = (t) => window.localStorage.getItem(t), Gr = (t) => window.localStorage.removeItem(t), Jr = {
  setItem: Yr,
  getItem: Hr,
  removeItem: Gr
}, { appDataStorageKey: Qr } = Lr;
function jt() {
  return JSON.parse(Jr.getItem(Qr) || "{}")?.customer || {};
}
const Xr = "reload-customer-section-data";
function en() {
  window.dispatchEvent(new CustomEvent(Xr));
}
var Nt = /* @__PURE__ */ ((t) => (t[t.TIER_1_GROUP_ID = 1] = "TIER_1_GROUP_ID", t[t.TIER_2_GROUP_ID = 2] = "TIER_2_GROUP_ID", t[t.TIER_3_GROUP_ID = 3] = "TIER_3_GROUP_ID", t[t.TIER_5_GROUP_ID = 5] = "TIER_5_GROUP_ID", t[t.TIER_8_GROUP_ID = 8] = "TIER_8_GROUP_ID", t[t.TIER_10_GROUP_ID = 10] = "TIER_10_GROUP_ID", t[t.TIER_0_GROUP_ID = 11] = "TIER_0_GROUP_ID", t[t.TIER_7_GROUP_ID = 12] = "TIER_7_GROUP_ID", t[t.TIER_13_GROUP_ID = 13] = "TIER_13_GROUP_ID", t[t.TIER_99_GROUP_ID = 14] = "TIER_99_GROUP_ID", t[t.TIER_9_GROUP_ID = 15] = "TIER_9_GROUP_ID", t[t.TIER_15_GROUP_ID = 16] = "TIER_15_GROUP_ID", t[t.TIER_16_GROUP_ID = 17] = "TIER_16_GROUP_ID", t[t.TIER_MCX_GROUP_ID = 21] = "TIER_MCX_GROUP_ID", t[t.TIER_400_GROUP_ID = 22] = "TIER_400_GROUP_ID", t))(Nt || {});
const ct = "unknown", tn = [
  { label: "0 - 10K", from: 0, to: 1e4 },
  { label: "10K - 50K", from: 1e4, to: 5e4 },
  { label: "50K - 100K", from: 5e4, to: 1e5 },
  { label: "100K - 250K", from: 1e5, to: 25e4 },
  { label: "250K - 500K", from: 25e4, to: 5e5 },
  { label: "500K+", from: 5e5 },
  { label: "I don't know", value: ct }
];
At(
  tn
);
const rn = [
  { label: "0 - 5k", from: 0, to: 5e3 },
  { label: "5K - 20k", from: 5e3, to: 2e4 },
  { label: "20K - 50k", from: 2e4, to: 5e4 },
  { label: "50K - 100k", from: 5e4, to: 1e5 },
  { label: "100K - 500k", from: 1e5, to: 5e5 },
  { label: "500k+", from: 5e5 },
  { label: "I don't know", value: ct }
], nn = [
  { label: "0 - 500", from: 0, to: 500 },
  { label: "500 - 2,000", from: 500, to: 2e3 },
  { label: "2,000 - 5,000", from: 2e3, to: 5e3 },
  { label: "5,000 - 10,000", from: 5e3, to: 1e4 },
  { label: "10,000 - 50,000", from: 1e4, to: 5e4 },
  { label: "50,000+", from: 5e4 },
  { label: "I don't know", value: ct }
], sn = Ot === "EU" ? nn : rn;
At(sn);
function At(t) {
  return t.map((e) => {
    const { label: r, from: n, to: s, value: a, ...i } = e;
    return a ? { ...e, value: `${e.value}` } : {
      label: r,
      value: `${n}-${s}`,
      from: n,
      to: s,
      ...i
    };
  });
}
const Ne = {
  openProjectCreateDialogEvent: "project-create-dialog-open-event",
  openProjectCreateDialogEventApiV2: "project-create-dialog-open-event-api-v2",
  openProjectCreateDialogEventLegacyFlow: "open-create-project-modal",
  projectCreateDialogProjectCreatedEvent: "project-create-dialog-project-created-event"
};
function an(t) {
  window.dispatchEvent(
    new CustomEvent(
      Ne.openProjectCreateDialogEventApiV2,
      {
        detail: t
      }
    )
  );
}
const on = "set-current-project-id", ua = Ne.projectCreateDialogProjectCreatedEvent, cn = {
  createProjectSubmitButton: "submit-create-project-button",
  showCreateProjectDialogButton: "show-create-project-button"
};
function la() {
  return { analyticsProps: Br({
    element: cn.showCreateProjectDialogButton
  }) };
}
function fa() {
  function t(e) {
    an(e);
  }
  return { onCreate: t };
}
var Zt = /* @__PURE__ */ ((t) => (t.Asc = "ASC", t.Desc = "DESC", t))(Zt || {}), H = /* @__PURE__ */ ((t) => (t.Active = "ACTIVE", t.OnHold = "ON_HOLD", t.Completed = "COMPLETED", t.Canceled = "CANCELED", t.Archived = "ARCHIVED", t))(H || {}), E = /* @__PURE__ */ ((t) => (t.January = "JANUARY", t.February = "FEBRUARY", t.March = "MARCH", t.April = "APRIL", t.May = "MAY", t.June = "JUNE", t.July = "JULY", t.August = "AUGUST", t.September = "SEPTEMBER", t.October = "OCTOBER", t.November = "NOVEMBER", t.December = "DECEMBER", t.NotSure = "NOT_SURE", t))(E || {});
const dn = {
  projectsV1: "rest/V1/sdg-api/projects",
  projectsV2: "rest/V2/sdg-api/projects",
  getProjectTypes: "sdg_project/project/listProjects",
  phasesRoute: "rest/V1/sdg-project/projectphase/search?searchCriteria[currentPage]=1",
  getLocations: "projects/api/locations",
  setUserCurrentProject: "sdg_project/project/projectssetlist",
  productServices: "mit_diverzify/diverzify",
  updateProject: "rest/V2/sdg-api/projects/mine",
  createProject: "projects/api/projects",
  getProjectBlacklistNames: "rest/V2/sdg-api/blacklist-projects/search"
}, A = Ve`
  fragment ProjectFragment on Project {
    id
    title
    country {
      code
    }
    state {
      code
    }
    city
    createdAt
    updatedAt
    externalId
    status
    userRef
    phase {
      code
      label
    }
    details
    type {
      code
      label
      externalId
    }
    budget {
      from
      to
      unit
    }
    size {
      from
      to
      unit
    }
    dueMonth
    dueYear
  }
`;
var x;
(function(t) {
  t.assertEqual = (s) => s;
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(x || (x = {}));
var et;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(et || (et = {}));
const p = x.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), U = (t) => {
  switch (typeof t) {
    case "undefined":
      return p.undefined;
    case "string":
      return p.string;
    case "number":
      return isNaN(t) ? p.nan : p.number;
    case "boolean":
      return p.boolean;
    case "function":
      return p.function;
    case "bigint":
      return p.bigint;
    case "symbol":
      return p.symbol;
    case "object":
      return Array.isArray(t) ? p.array : t === null ? p.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? p.promise : typeof Map < "u" && t instanceof Map ? p.map : typeof Set < "u" && t instanceof Set ? p.set : typeof Date < "u" && t instanceof Date ? p.date : p.object;
    default:
      return p.unknown;
  }
}, d = x.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), un = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class R extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, c = 0;
          for (; c < i.path.length; ) {
            const u = i.path[c];
            c === i.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(i))) : o[u] = o[u] || { _errors: [] }, o = o[u], c++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof R))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, x.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
R.create = (t) => new R(t);
const ne = (t, e) => {
  let r;
  switch (t.code) {
    case d.invalid_type:
      t.received === p.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case d.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, x.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${x.joinValues(t.keys, ", ")}`;
      break;
    case d.invalid_union:
      r = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${x.joinValues(t.options)}`;
      break;
    case d.invalid_enum_value:
      r = `Invalid enum value. Expected ${x.joinValues(t.options)}, received '${t.received}'`;
      break;
    case d.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      r = "Invalid function return type";
      break;
    case d.invalid_date:
      r = "Invalid date";
      break;
    case d.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : x.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case d.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case d.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case d.custom:
      r = "Invalid input";
      break;
    case d.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case d.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, x.assertNever(t);
  }
  return { message: r };
};
let Dt = ne;
function ln(t) {
  Dt = t;
}
function Ae() {
  return Dt;
}
const Ze = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, a = [...r, ...s.path || []], i = {
    ...s,
    path: a
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: a,
      message: s.message
    };
  let o = "";
  const c = n.filter((u) => !!u).slice().reverse();
  for (const u of c)
    o = u(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: o
  };
}, fn = [];
function f(t, e) {
  const r = Ae(), n = Ze({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      r,
      r === ne ? void 0 : ne
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(n);
}
class C {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r) {
      const a = await s.key, i = await s.value;
      n.push({
        key: a,
        value: i
      });
    }
    return C.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return y;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (n[a.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const y = Object.freeze({
  status: "aborted"
}), ee = (t) => ({ status: "dirty", value: t }), P = (t) => ({ status: "valid", value: t }), tt = (t) => t.status === "aborted", rt = (t) => t.status === "dirty", fe = (t) => t.status === "valid", pe = (t) => typeof Promise < "u" && t instanceof Promise;
function De(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function Mt(t, e, r, n, s) {
  if (typeof e == "function" ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var m;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(m || (m = {}));
var ue, le;
class D {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Tt = (t, e) => {
  if (fe(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new R(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function v(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    var c, u;
    const { message: h } = t;
    return i.code === "invalid_enum_value" ? { message: h ?? o.defaultError } : typeof o.data > "u" ? { message: (c = h ?? n) !== null && c !== void 0 ? c : o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: (u = h ?? r) !== null && u !== void 0 ? u : o.defaultError };
  }, description: s };
}
class b {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return U(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: U(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new C(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: U(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (pe(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r?.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: U(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return Tt(s, a);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: U(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), a = await (pe(s) ? s : Promise.resolve(s));
    return Tt(n, a);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: d.custom,
        ...n(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new N({
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return Z.create(this, this._def);
  }
  nullable() {
    return q.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return O.create(this, this._def);
  }
  promise() {
    return ae.create(this, this._def);
  }
  or(e) {
    return ye.create([this, e], this._def);
  }
  and(e) {
    return ve.create(this, e, this._def);
  }
  transform(e) {
    return new N({
      ...v(this._def),
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new ke({
      ...v(this._def),
      innerType: this,
      defaultValue: r,
      typeName: g.ZodDefault
    });
  }
  brand() {
    return new dt({
      typeName: g.ZodBranded,
      type: this,
      ...v(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new je({
      ...v(this._def),
      innerType: this,
      catchValue: r,
      typeName: g.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Pe.create(this, e);
  }
  readonly() {
    return Te.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const pn = /^c[^\s-]{8,}$/i, hn = /^[0-9a-z]+$/, mn = /^[0-9A-HJKMNP-TV-Z]{26}$/, gn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, yn = /^[a-z0-9_-]{21}$/i, vn = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, _n = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, bn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Je;
const xn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, wn = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, kn = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, $t = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", jn = new RegExp(`^${$t}$`);
function Lt(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Tn(t) {
  return new RegExp(`^${Lt(t)}$`);
}
function Ut(t) {
  let e = `${$t}T${Lt(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function En(t, e) {
  return !!((e === "v4" || !e) && xn.test(t) || (e === "v6" || !e) && wn.test(t));
}
class I extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== p.string) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: d.invalid_type,
        expected: p.string,
        received: a.parsedType
      }), y;
    }
    const n = new C();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), f(s, {
          code: d.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), f(s, {
          code: d.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? f(s, {
          code: d.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && f(s, {
          code: d.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        _n.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "email",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Je || (Je = new RegExp(bn, "u")), Je.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "emoji",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        gn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "uuid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        yn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "nanoid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        pn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "cuid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        hn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "cuid2",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        mn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
          validation: "ulid",
          code: d.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), f(s, {
            validation: "url",
            code: d.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "regex",
        code: d.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? Ut(a).test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? jn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? Tn(a).test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? vn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "duration",
        code: d.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? En(e.data, a.version) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "ip",
        code: d.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? kn.test(e.data) || (s = this._getOrReturnCtx(e, s), f(s, {
        validation: "base64",
        code: d.invalid_string,
        message: a.message
      }), n.dirty()) : x.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: d.invalid_string,
      ...m.errToObj(n)
    });
  }
  _addCheck(e) {
    return new I({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...m.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...m.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...m.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...m.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...m.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...m.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...m.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...m.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...m.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...m.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (r = e?.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e?.local) !== null && n !== void 0 ? n : !1,
      ...m.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...m.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...m.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...m.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r?.position,
      ...m.errToObj(r?.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...m.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...m.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...m.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...m.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...m.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, m.errToObj(e));
  }
  trim() {
    return new I({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new I({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new I({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
I.create = (t) => {
  var e;
  return new I({
    checks: [],
    typeName: g.ZodString,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...v(t)
  });
};
function Cn(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, a = parseInt(t.toFixed(s).replace(".", "")), i = parseInt(e.toFixed(s).replace(".", ""));
  return a % i / Math.pow(10, s);
}
class B extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== p.number) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: d.invalid_type,
        expected: p.number,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new C();
    for (const a of this._def.checks)
      a.kind === "int" ? x.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? Cn(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.not_finite,
        message: a.message
      }), s.dirty()) : x.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, m.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, m.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, m.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, m.toString(r));
  }
  setLimit(e, r, n, s) {
    return new B({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: m.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new B({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: m.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: m.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: m.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: m.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && x.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
B.create = (t) => new B({
  checks: [],
  typeName: g.ZodNumber,
  coerce: t?.coerce || !1,
  ...v(t)
});
class z extends b {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== p.bigint) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: d.invalid_type,
        expected: p.bigint,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new C();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : x.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, m.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, m.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, m.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, m.toString(r));
  }
  setLimit(e, r, n, s) {
    return new z({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: m.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new z({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: m.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: m.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: m.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
z.create = (t) => {
  var e;
  return new z({
    checks: [],
    typeName: g.ZodBigInt,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...v(t)
  });
};
class he extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== p.boolean) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.boolean,
        received: n.parsedType
      }), y;
    }
    return P(e.data);
  }
}
he.create = (t) => new he({
  typeName: g.ZodBoolean,
  coerce: t?.coerce || !1,
  ...v(t)
});
class J extends b {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== p.date) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: d.invalid_type,
        expected: p.date,
        received: a.parsedType
      }), y;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return f(a, {
        code: d.invalid_date
      }), y;
    }
    const n = new C();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), f(s, {
        code: d.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : x.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new J({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: m.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: m.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
J.create = (t) => new J({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: g.ZodDate,
  ...v(t)
});
class Me extends b {
  _parse(e) {
    if (this._getType(e) !== p.symbol) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.symbol,
        received: n.parsedType
      }), y;
    }
    return P(e.data);
  }
}
Me.create = (t) => new Me({
  typeName: g.ZodSymbol,
  ...v(t)
});
class me extends b {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.undefined,
        received: n.parsedType
      }), y;
    }
    return P(e.data);
  }
}
me.create = (t) => new me({
  typeName: g.ZodUndefined,
  ...v(t)
});
class ge extends b {
  _parse(e) {
    if (this._getType(e) !== p.null) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.null,
        received: n.parsedType
      }), y;
    }
    return P(e.data);
  }
}
ge.create = (t) => new ge({
  typeName: g.ZodNull,
  ...v(t)
});
class se extends b {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return P(e.data);
  }
}
se.create = (t) => new se({
  typeName: g.ZodAny,
  ...v(t)
});
class G extends b {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return P(e.data);
  }
}
G.create = (t) => new G({
  typeName: g.ZodUnknown,
  ...v(t)
});
class L extends b {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return f(r, {
      code: d.invalid_type,
      expected: p.never,
      received: r.parsedType
    }), y;
  }
}
L.create = (t) => new L({
  typeName: g.ZodNever,
  ...v(t)
});
class $e extends b {
  _parse(e) {
    if (this._getType(e) !== p.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.void,
        received: n.parsedType
      }), y;
    }
    return P(e.data);
  }
}
$e.create = (t) => new $e({
  typeName: g.ZodVoid,
  ...v(t)
});
class O extends b {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== p.array)
      return f(r, {
        code: d.invalid_type,
        expected: p.array,
        received: r.parsedType
      }), y;
    if (s.exactLength !== null) {
      const i = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (i || o) && (f(r, {
        code: i ? d.too_big : d.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (f(r, {
      code: d.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (f(r, {
      code: d.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => s.type._parseAsync(new D(r, i, r.path, o)))).then((i) => C.mergeArray(n, i));
    const a = [...r.data].map((i, o) => s.type._parseSync(new D(r, i, r.path, o)));
    return C.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new O({
      ...this._def,
      minLength: { value: e, message: m.toString(r) }
    });
  }
  max(e, r) {
    return new O({
      ...this._def,
      maxLength: { value: e, message: m.toString(r) }
    });
  }
  length(e, r) {
    return new O({
      ...this._def,
      exactLength: { value: e, message: m.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
O.create = (t, e) => new O({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g.ZodArray,
  ...v(e)
});
function X(t) {
  if (t instanceof k) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = Z.create(X(n));
    }
    return new k({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof O ? new O({
    ...t._def,
    type: X(t.element)
  }) : t instanceof Z ? Z.create(X(t.unwrap())) : t instanceof q ? q.create(X(t.unwrap())) : t instanceof M ? M.create(t.items.map((e) => X(e))) : t;
}
class k extends b {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = x.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== p.object) {
      const u = this._getOrReturnCtx(e);
      return f(u, {
        code: d.invalid_type,
        expected: p.object,
        received: u.parsedType
      }), y;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof L && this._def.unknownKeys === "strip"))
      for (const u in s.data)
        i.includes(u) || o.push(u);
    const c = [];
    for (const u of i) {
      const h = a[u], T = s.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: h._parse(new D(s, T, s.path, u)),
        alwaysSet: u in s.data
      });
    }
    if (this._def.catchall instanceof L) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const h of o)
          c.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: s.data[h] }
          });
      else if (u === "strict")
        o.length > 0 && (f(s, {
          code: d.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const h of o) {
        const T = s.data[h];
        c.push({
          key: { status: "valid", value: h },
          value: u._parse(
            new D(s, T, s.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const h of c) {
        const T = await h.key, Re = await h.value;
        u.push({
          key: T,
          value: Re,
          alwaysSet: h.alwaysSet
        });
      }
      return u;
    }).then((u) => C.mergeObjectSync(n, u)) : C.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return m.errToObj, new k({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var s, a, i, o;
          const c = (i = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, r, n).message) !== null && i !== void 0 ? i : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = m.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new k({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new k({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new k({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new k({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new k({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return x.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return X(this);
  }
  partial(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof Z; )
          a = a._def.innerType;
        r[n] = a;
      }
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Vt(x.objectKeys(this.shape));
  }
}
k.create = (t, e) => new k({
  shape: () => t,
  unknownKeys: "strip",
  catchall: L.create(),
  typeName: g.ZodObject,
  ...v(e)
});
k.strictCreate = (t, e) => new k({
  shape: () => t,
  unknownKeys: "strict",
  catchall: L.create(),
  typeName: g.ZodObject,
  ...v(e)
});
k.lazycreate = (t, e) => new k({
  shape: t,
  unknownKeys: "strip",
  catchall: L.create(),
  typeName: g.ZodObject,
  ...v(e)
});
class ye extends b {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new R(o.ctx.common.issues));
      return f(r, {
        code: d.invalid_union,
        unionErrors: i
      }), y;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const c of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = c._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !a && (a = { result: h, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((c) => new R(c));
      return f(r, {
        code: d.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
ye.create = (t, e) => new ye({
  options: t,
  typeName: g.ZodUnion,
  ...v(e)
});
const $ = (t) => t instanceof be ? $(t.schema) : t instanceof N ? $(t.innerType()) : t instanceof xe ? [t.value] : t instanceof F ? t.options : t instanceof we ? x.objectValues(t.enum) : t instanceof ke ? $(t._def.innerType) : t instanceof me ? [void 0] : t instanceof ge ? [null] : t instanceof Z ? [void 0, ...$(t.unwrap())] : t instanceof q ? [null, ...$(t.unwrap())] : t instanceof dt || t instanceof Te ? $(t.unwrap()) : t instanceof je ? $(t._def.innerType) : [];
class ze extends b {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== p.object)
      return f(r, {
        code: d.invalid_type,
        expected: p.object,
        received: r.parsedType
      }), y;
    const n = this.discriminator, s = r.data[n], a = this.optionsMap.get(s);
    return a ? r.common.async ? a._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : a._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (f(r, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const a of r) {
      const i = $(a.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new ze({
      typeName: g.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: s,
      ...v(n)
    });
  }
}
function nt(t, e) {
  const r = U(t), n = U(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === p.object && n === p.object) {
    const s = x.objectKeys(e), a = x.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const c = nt(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      i[o] = c.data;
    }
    return { valid: !0, data: i };
  } else if (r === p.array && n === p.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], c = nt(i, o);
      if (!c.valid)
        return { valid: !1 };
      s.push(c.data);
    }
    return { valid: !0, data: s };
  } else return r === p.date && n === p.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ve extends b {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (a, i) => {
      if (tt(a) || tt(i))
        return y;
      const o = nt(a.value, i.value);
      return o.valid ? ((rt(a) || rt(i)) && r.dirty(), { status: r.value, value: o.data }) : (f(n, {
        code: d.invalid_intersection_types
      }), y);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ve.create = (t, e, r) => new ve({
  left: t,
  right: e,
  typeName: g.ZodIntersection,
  ...v(r)
});
class M extends b {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.array)
      return f(n, {
        code: d.invalid_type,
        expected: p.array,
        received: n.parsedType
      }), y;
    if (n.data.length < this._def.items.length)
      return f(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && n.data.length > this._def.items.length && (f(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((i, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new D(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(a).then((i) => C.mergeArray(r, i)) : C.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new M({
      ...this._def,
      rest: e
    });
  }
}
M.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new M({
    items: t,
    typeName: g.ZodTuple,
    rest: null,
    ...v(e)
  });
};
class _e extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.object)
      return f(n, {
        code: d.invalid_type,
        expected: p.object,
        received: n.parsedType
      }), y;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: a._parse(new D(n, o, n.path, o)),
        value: i._parse(new D(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? C.mergeObjectAsync(r, s) : C.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof b ? new _e({
      keyType: e,
      valueType: r,
      typeName: g.ZodRecord,
      ...v(n)
    }) : new _e({
      keyType: I.create(),
      valueType: e,
      typeName: g.ZodRecord,
      ...v(r)
    });
  }
}
class Le extends b {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.map)
      return f(n, {
        code: d.invalid_type,
        expected: p.map,
        received: n.parsedType
      }), y;
    const s = this._def.keyType, a = this._def.valueType, i = [...n.data.entries()].map(([o, c], u) => ({
      key: s._parse(new D(n, o, n.path, [u, "key"])),
      value: a._parse(new D(n, c, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const u = await c.key, h = await c.value;
          if (u.status === "aborted" || h.status === "aborted")
            return y;
          (u.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(u.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of i) {
        const u = c.key, h = c.value;
        if (u.status === "aborted" || h.status === "aborted")
          return y;
        (u.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(u.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Le.create = (t, e, r) => new Le({
  valueType: e,
  keyType: t,
  typeName: g.ZodMap,
  ...v(r)
});
class Q extends b {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== p.set)
      return f(n, {
        code: d.invalid_type,
        expected: p.set,
        received: n.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (f(n, {
      code: d.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (f(n, {
      code: d.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function i(c) {
      const u = /* @__PURE__ */ new Set();
      for (const h of c) {
        if (h.status === "aborted")
          return y;
        h.status === "dirty" && r.dirty(), u.add(h.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...n.data.values()].map((c, u) => a._parse(new D(n, c, n.path, u)));
    return n.common.async ? Promise.all(o).then((c) => i(c)) : i(o);
  }
  min(e, r) {
    return new Q({
      ...this._def,
      minSize: { value: e, message: m.toString(r) }
    });
  }
  max(e, r) {
    return new Q({
      ...this._def,
      maxSize: { value: e, message: m.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Q.create = (t, e) => new Q({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: g.ZodSet,
  ...v(e)
});
class te extends b {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== p.function)
      return f(r, {
        code: d.invalid_type,
        expected: p.function,
        received: r.parsedType
      }), y;
    function n(o, c) {
      return Ze({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Ae(),
          ne
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function s(o, c) {
      return Ze({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Ae(),
          ne
        ].filter((u) => !!u),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: r.common.contextualErrorMap }, i = r.data;
    if (this._def.returns instanceof ae) {
      const o = this;
      return P(async function(...c) {
        const u = new R([]), h = await o._def.args.parseAsync(c, a).catch((oe) => {
          throw u.addIssue(n(c, oe)), u;
        }), T = await Reflect.apply(i, this, h);
        return await o._def.returns._def.type.parseAsync(T, a).catch((oe) => {
          throw u.addIssue(s(T, oe)), u;
        });
      });
    } else {
      const o = this;
      return P(function(...c) {
        const u = o._def.args.safeParse(c, a);
        if (!u.success)
          throw new R([n(c, u.error)]);
        const h = Reflect.apply(i, this, u.data), T = o._def.returns.safeParse(h, a);
        if (!T.success)
          throw new R([s(h, T.error)]);
        return T.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new te({
      ...this._def,
      args: M.create(e).rest(G.create())
    });
  }
  returns(e) {
    return new te({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new te({
      args: e || M.create([]).rest(G.create()),
      returns: r || G.create(),
      typeName: g.ZodFunction,
      ...v(n)
    });
  }
}
class be extends b {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
be.create = (t, e) => new be({
  getter: t,
  typeName: g.ZodLazy,
  ...v(e)
});
class xe extends b {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        received: r.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
xe.create = (t, e) => new xe({
  value: t,
  typeName: g.ZodLiteral,
  ...v(e)
});
function Vt(t, e) {
  return new F({
    values: t,
    typeName: g.ZodEnum,
    ...v(e)
  });
}
class F extends b {
  constructor() {
    super(...arguments), ue.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return f(r, {
        expected: x.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (De(this, ue) || Mt(this, ue, new Set(this._def.values)), !De(this, ue).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return f(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), y;
    }
    return P(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return F.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return F.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
ue = /* @__PURE__ */ new WeakMap();
F.create = Vt;
class we extends b {
  constructor() {
    super(...arguments), le.set(this, void 0);
  }
  _parse(e) {
    const r = x.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== p.string && n.parsedType !== p.number) {
      const s = x.objectValues(r);
      return f(n, {
        expected: x.joinValues(s),
        received: n.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (De(this, le) || Mt(this, le, new Set(x.getValidEnumValues(this._def.values))), !De(this, le).has(e.data)) {
      const s = x.objectValues(r);
      return f(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: s
      }), y;
    }
    return P(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
le = /* @__PURE__ */ new WeakMap();
we.create = (t, e) => new we({
  values: t,
  typeName: g.ZodNativeEnum,
  ...v(e)
});
class ae extends b {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== p.promise && r.common.async === !1)
      return f(r, {
        code: d.invalid_type,
        expected: p.promise,
        received: r.parsedType
      }), y;
    const n = r.parsedType === p.promise ? r.data : Promise.resolve(r.data);
    return P(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
ae.create = (t, e) => new ae({
  type: t,
  typeName: g.ZodPromise,
  ...v(e)
});
class N extends b {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        f(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return y;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? y : c.status === "dirty" || r.value === "dirty" ? ee(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return y;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : o.status === "dirty" || r.value === "dirty" ? ee(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const c = s.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!fe(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => fe(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({ status: r.value, value: o })) : i);
    x.assertNever(s);
  }
}
N.create = (t, e, r) => new N({
  schema: t,
  typeName: g.ZodEffects,
  effect: e,
  ...v(r)
});
N.createWithPreprocess = (t, e, r) => new N({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: g.ZodEffects,
  ...v(r)
});
class Z extends b {
  _parse(e) {
    return this._getType(e) === p.undefined ? P(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Z.create = (t, e) => new Z({
  innerType: t,
  typeName: g.ZodOptional,
  ...v(e)
});
class q extends b {
  _parse(e) {
    return this._getType(e) === p.null ? P(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
q.create = (t, e) => new q({
  innerType: t,
  typeName: g.ZodNullable,
  ...v(e)
});
class ke extends b {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === p.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ke.create = (t, e) => new ke({
  innerType: t,
  typeName: g.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...v(e)
});
class je extends b {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return pe(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new R(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new R(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
je.create = (t, e) => new je({
  innerType: t,
  typeName: g.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...v(e)
});
class Ue extends b {
  _parse(e) {
    if (this._getType(e) !== p.nan) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: d.invalid_type,
        expected: p.nan,
        received: n.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
Ue.create = (t) => new Ue({
  typeName: g.ZodNaN,
  ...v(t)
});
const Pn = Symbol("zod_brand");
class dt extends b {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Pe extends b {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? y : a.status === "dirty" ? (r.dirty(), ee(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new Pe({
      in: e,
      out: r,
      typeName: g.ZodPipeline
    });
  }
}
class Te extends b {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (s) => (fe(s) && (s.value = Object.freeze(s.value)), s);
    return pe(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Te.create = (t, e) => new Te({
  innerType: t,
  typeName: g.ZodReadonly,
  ...v(e)
});
function Bt(t, e = {}, r) {
  return t ? se.create().superRefine((n, s) => {
    var a, i;
    if (!t(n)) {
      const o = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, c = (i = (a = o.fatal) !== null && a !== void 0 ? a : r) !== null && i !== void 0 ? i : !0, u = typeof o == "string" ? { message: o } : o;
      s.addIssue({ code: "custom", ...u, fatal: c });
    }
  }) : se.create();
}
const Rn = {
  object: k.lazycreate
};
var g;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(g || (g = {}));
const Sn = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Bt((r) => r instanceof t, e), zt = I.create, Ft = B.create, In = Ue.create, On = z.create, qt = he.create, Nn = J.create, An = Me.create, Zn = me.create, Dn = ge.create, Mn = se.create, $n = G.create, Ln = L.create, Un = $e.create, Vn = O.create, Bn = k.create, zn = k.strictCreate, Fn = ye.create, qn = ze.create, Kn = ve.create, Wn = M.create, Yn = _e.create, Hn = Le.create, Gn = Q.create, Jn = te.create, Qn = be.create, Xn = xe.create, es = F.create, ts = we.create, rs = ae.create, Et = N.create, ns = Z.create, ss = q.create, as = N.createWithPreprocess, is = Pe.create, os = () => zt().optional(), cs = () => Ft().optional(), ds = () => qt().optional(), us = {
  string: (t) => I.create({ ...t, coerce: !0 }),
  number: (t) => B.create({ ...t, coerce: !0 }),
  boolean: (t) => he.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => z.create({ ...t, coerce: !0 }),
  date: (t) => J.create({ ...t, coerce: !0 })
}, ls = y;
var j = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: ne,
  setErrorMap: ln,
  getErrorMap: Ae,
  makeIssue: Ze,
  EMPTY_PATH: fn,
  addIssueToContext: f,
  ParseStatus: C,
  INVALID: y,
  DIRTY: ee,
  OK: P,
  isAborted: tt,
  isDirty: rt,
  isValid: fe,
  isAsync: pe,
  get util() {
    return x;
  },
  get objectUtil() {
    return et;
  },
  ZodParsedType: p,
  getParsedType: U,
  ZodType: b,
  datetimeRegex: Ut,
  ZodString: I,
  ZodNumber: B,
  ZodBigInt: z,
  ZodBoolean: he,
  ZodDate: J,
  ZodSymbol: Me,
  ZodUndefined: me,
  ZodNull: ge,
  ZodAny: se,
  ZodUnknown: G,
  ZodNever: L,
  ZodVoid: $e,
  ZodArray: O,
  ZodObject: k,
  ZodUnion: ye,
  ZodDiscriminatedUnion: ze,
  ZodIntersection: ve,
  ZodTuple: M,
  ZodRecord: _e,
  ZodMap: Le,
  ZodSet: Q,
  ZodFunction: te,
  ZodLazy: be,
  ZodLiteral: xe,
  ZodEnum: F,
  ZodNativeEnum: we,
  ZodPromise: ae,
  ZodEffects: N,
  ZodTransformer: N,
  ZodOptional: Z,
  ZodNullable: q,
  ZodDefault: ke,
  ZodCatch: je,
  ZodNaN: Ue,
  BRAND: Pn,
  ZodBranded: dt,
  ZodPipeline: Pe,
  ZodReadonly: Te,
  custom: Bt,
  Schema: b,
  ZodSchema: b,
  late: Rn,
  get ZodFirstPartyTypeKind() {
    return g;
  },
  coerce: us,
  any: Mn,
  array: Vn,
  bigint: On,
  boolean: qt,
  date: Nn,
  discriminatedUnion: qn,
  effect: Et,
  enum: es,
  function: Jn,
  instanceof: Sn,
  intersection: Kn,
  lazy: Qn,
  literal: Xn,
  map: Hn,
  nan: In,
  nativeEnum: ts,
  never: Ln,
  null: Dn,
  nullable: ss,
  number: Ft,
  object: Bn,
  oboolean: ds,
  onumber: cs,
  optional: ns,
  ostring: os,
  pipeline: is,
  preprocess: as,
  promise: rs,
  record: Yn,
  set: Gn,
  strictObject: zn,
  string: zt,
  symbol: An,
  transformer: Et,
  tuple: Wn,
  undefined: Zn,
  union: Fn,
  unknown: $n,
  void: Un,
  NEVER: ls,
  ZodIssueCode: d,
  quotelessJson: un,
  ZodError: R
});
function fs() {
  function t(e) {
    return Vr(dn.setUserCurrentProject, {
      method: "POST",
      data: {
        project_id: Number(e)
      }
    });
  }
  return { setUserCurrentProject: t };
}
const ps = Ve`
  mutation UpdateProjectMutation($id: UUID!, $input: ProjectInput!) {
    patchProject(id: $id, input: $input) {
      ...ProjectFragment
    }
  }
  ${A}
`;
function hs() {
  return Rr(ps);
}
const ms = Ve`
  query ProjectsQuery(
    $statuses: [ProjectStatus!]
    $excludedStatuses: [ProjectStatus!]
    $page: Int
    $pageSize: Int
    $sortBy: ProjectSortableField
    $sortDirection: SortDirection
  ) {
    projects(
      statuses: $statuses
      excludedStatuses: $excludedStatuses
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        ...ProjectFragment
      }
      currentPage
    }
  }
  ${A}
`;
function gs(t) {
  return { ...St(ms, t) };
}
function ys() {
  const [t, e] = Qe(!0), [r, n] = Qe(
    () => {
      const s = jt();
      return kt(s) ? null : (e(!1), s);
    }
  );
  return Ee(() => {
    const s = jt();
    kt(s) || (n(s), e(!1));
    function a(i) {
      n(i.detail.data.customer), e(!1);
    }
    return window.addEventListener(xt, a), () => {
      window.removeEventListener(
        xt,
        a
      );
    };
  }, []), {
    isLoading: t,
    customer: r
  };
}
const { Provider: vs, useContext: Kt } = zr();
function _s({ children: t }) {
  const { isLoading: e, customer: r } = ys(), n = ot(() => ({
    isLoading: e,
    customer: r
  }), [e, r]);
  return /* @__PURE__ */ _(vs, { value: n, children: t });
}
const bs = "select-project-timestamp";
function xs() {
  localStorage.setItem(bs, String(Date.now()));
}
function ws(t) {
  window.dispatchEvent(
    new CustomEvent(on, {
      detail: { projectId: t }
    })
  );
}
function Wt() {
  const { customer: t } = Kt(), { setUserCurrentProject: e } = fs(), { currentProjectId: r, setCurrentProject: n } = ks();
  Ee(() => {
    r || n(t?.current_project ?? null);
  }, [r, t?.current_project, n]);
  async function s(a, i) {
    if (!a)
      return;
    const o = r;
    n(a);
    try {
      if ((await e(a))?.data?.status !== "success") {
        n(o);
        return;
      }
      xs(), ws(a), en();
    } catch (c) {
      n(o), i?.(c);
    }
  }
  return {
    currentExternalProjectId: r,
    setCurrentProjectId: s
  };
}
const Ct = Ve`
  query GetCurrentProject {
    currentProjectId @client
  }
`;
function ks() {
  const t = Be(), { data: e, refetch: r } = St(Ct);
  function n(s) {
    t.writeQuery({
      query: Ct,
      data: {
        currentProjectId: s
      },
      overwrite: !0
    }), r();
  }
  return {
    currentProjectId: e?.currentProjectId,
    setCurrentProject: n
  };
}
const js = 1e9;
function Yt({ variables: t, options: e } = {
  variables: {},
  options: {}
}) {
  return gs({
    variables: {
      page: 1,
      pageSize: js,
      sortDirection: Zt.Asc,
      ...t
    },
    fetchPolicy: "cache-first",
    ...e
  });
}
function pa() {
  const { currentExternalProjectId: t, setCurrentProjectId: e } = Wt(), { data: r, loading: n } = Yt(), s = r?.projects.items ?? [];
  let a = null;
  return a = t ? s.find(
    (i) => i.externalId === parseInt(t)
  ) ?? null : null, { currentProject: a, loading: n, setCurrentProjectId: e };
}
const st = {
  openProjectEditDialogEvent: "project-edit-dialog-open-event",
  projectEditDialogProjectUpdatedEvent: "project-edit-dialog-project-updated-event"
};
function Ht(t) {
  window.dispatchEvent(
    new CustomEvent(
      st.openProjectEditDialogEvent,
      {
        detail: t
      }
    )
  );
}
function ha() {
  function t(e) {
    Ht({
      projectId: e
    });
  }
  return { onEdit: t };
}
function ma() {
  const t = Be();
  Ee(() => {
    async function e(r) {
      const { detail: n } = r;
      if (!n || !n?.project)
        return;
      const s = n.project;
      t.cache.readFragment({
        id: `Project:${s.id}`,
        fragment: A
      }) || (t.cache.writeFragment({
        id: `Project:${s.id}`,
        fragment: A,
        data: s
      }), t.cache.modify({
        fields: {
          projects(i = { items: [] }) {
            const o = t.cache.writeFragment({
              data: s,
              fragment: A
            });
            return {
              ...i,
              items: [o, ...i.items]
            };
          }
        }
      }));
    }
    return window.addEventListener(
      Ne.projectCreateDialogProjectCreatedEvent,
      e
    ), () => {
      window.removeEventListener(
        Ne.projectCreateDialogProjectCreatedEvent,
        e
      );
    };
  }, [t]);
}
function ga() {
  const t = Be();
  Ee(() => {
    async function e(r) {
      const { detail: n } = r;
      if (!n || !n?.project)
        return;
      const s = n.project, a = t.cache.readFragment({
        id: `Project:${s.id}`,
        fragment: A
      });
      a && a.updatedAt === s.updatedAt || (t.cache.writeFragment({
        id: `Project:${s.id}`,
        fragment: A,
        data: s
      }), t.cache.modify({
        fields: {
          projects(i = { items: [] }) {
            const o = t.cache.writeFragment({
              data: s,
              fragment: A
            });
            return {
              ...i,
              items: i.items.map(
                (c) => c.__ref === `Project:${s.id}` ? o : c
              )
            };
          }
        }
      }));
    }
    return window.addEventListener(
      st.projectEditDialogProjectUpdatedEvent,
      e
    ), () => {
      window.removeEventListener(
        st.projectEditDialogProjectUpdatedEvent,
        e
      );
    };
  }, [t]);
}
function ya() {
  const t = Be(), [e, { loading: r }] = hs();
  function n(s, a, i) {
    const o = t.readFragment({
      id: `Project:${s.id}`,
      fragment: A
    });
    return e({
      variables: s,
      optimisticResponse: {
        patchProject: {
          __typename: "Project",
          ...o,
          ...a
        }
      },
      update: (c, { data: u }) => {
        if (!u)
          return;
        const h = u.patchProject;
        c.writeFragment({
          id: `Project:${h.id}`,
          fragment: A,
          data: h
        });
      },
      onError: (c) => {
        console.error(c), i?.(c);
      }
    });
  }
  return { loading: r, updateProject: n };
}
function Ts({
  children: t,
  ...e
}) {
  return /* @__PURE__ */ _(
    Ir,
    {
      componentsProps: {
        tooltip: {
          sx: {
            backgroundColor: "primary.main",
            borderRadius: "50px"
          }
        }
      },
      ...e,
      children: t
    }
  );
}
const Es = /^[^-\s][a-zA-Z0-9\u00C0-\u017F\s\-\.\']*$/, at = Ot === "US";
function Cs(t, e) {
  if (!t)
    return !1;
  const r = t.toLowerCase();
  return e.map(
    (s) => new RegExp(`\\b${s.toLowerCase()}\\b`, "gi")
  ).some((s) => s.test(r));
}
const Gt = (t, e) => {
  const r = e === Nt.TIER_13_GROUP_ID;
  return j.object({
    name: j.string().min(1, "Name is required").refine((n) => Es.test(n), "Please enter a valid Project name.").refine((n) => !Cs(n, t), "Please enter a valid Project name."),
    country: j.string().min(1, "Country is required"),
    city: r ? j.string().nullable().optional() : j.string().min(1, "Please add city to your project"),
    state: r ? j.string().nullable().optional() : j.string().min(1, "State is required"),
    type: j.string().min(1, "Type is required"),
    phase: r ? j.string().nullable().optional() : j.string().min(1, "Phase is required"),
    size: r ? j.string().nullable().optional() : j.string().min(1, "Size is required"),
    budget: r ? j.string().nullable().optional() : j.string().min(1, "Budget is required"),
    dueMonth: r ? j.enum(Object.values(E)).nullable().optional() : j.enum(Object.values(E), {
      errorMap: () => ({ message: "Select correct month and year" })
    }),
    dueYear: r ? j.string().nullable().optional() : j.string().min(1, "Select correct month and year"),
    description: r ? j.string().nullable().optional() : j.string().min(1, "Please provide more information about your project").min(20, "Please provide more information about your project")
  });
}, Ps = (t, e) => Gt(t, e).omit({
  state: !0
}), Rs = (t, e) => {
  const r = at ? Gt(t, e) : Ps(t, e);
  return Object.keys(r.shape).filter((n) => {
    const s = r.shape[n];
    return !(s instanceof j.ZodOptional || s instanceof j.ZodNullable);
  });
}, Ss = {
  name: "title",
  country: "country",
  state: "state",
  city: "city",
  type: "type",
  phase: "phase",
  size: "size",
  budget: "budget",
  dueMonth: "dueMonth",
  dueYear: "dueYear",
  description: "details"
}, Is = ["size", "budget"];
E.January + "", E.February + "", E.March + "", E.April + "", E.May + "", E.June + "", E.July + "", E.August + "", E.September + "", E.October + "", E.November + "", E.December + "", E.NotSure + "";
const Os = Pt.createContext(null), Ns = () => Pt.useContext(Os), ut = Ns;
it(
  {}
);
const Jt = ie(
  (t, e) => {
    const r = `py-0 px-4 text-gray ${t.InputProps?.endAdornment ? "pr-10" : ""}`;
    return /* @__PURE__ */ _(
      Or,
      {
        ...t,
        ref: e,
        className: "h-9 md:h-12 rounded-full py-0 bg-[#F5F5F7] focus:border-[#B9C8F4] focus:outline-none",
        variant: "outlined",
        InputProps: {
          ...t.InputProps,
          classes: {
            notchedOutline: t.error ? "" : "border-none",
            input: r
          },
          className: "h-9 md:h-12 rounded-full p-0"
        }
      }
    );
  }
);
Jt.displayName = "TextField";
function As() {
  return /* @__PURE__ */ _(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ _(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53267 7.63325C7.77675 7.38918 8.17247 7.38918 8.41655 7.63325L11.9746 11.1913L15.5327 7.63325C15.7767 7.38918 16.1725 7.38918 16.4166 7.63325C16.6606 7.87733 16.6606 8.27306 16.4166 8.51714L12.8585 12.0752L16.4166 15.6333C16.6606 15.8773 16.6606 16.2731 16.4166 16.5171C16.1725 16.7612 15.7767 16.7612 15.5327 16.5171L11.9746 12.9591L8.41655 16.5171C8.17247 16.7612 7.77675 16.7612 7.53267 16.5171C7.28859 16.2731 7.28859 15.8773 7.53267 15.6333L11.0907 12.0752L7.53267 8.51714C7.28859 8.27306 7.28859 7.87733 7.53267 7.63325Z",
          fill: "#4D4E58"
        }
      )
    }
  );
}
const Zs = ie(
  ({ initialValue: t, onClear: e, ...r }, n) => {
    const { setValue: s } = ut(), [a, i] = Qe(t ?? "");
    Ee(() => {
      t && i(t);
    }, [t]);
    function o(u) {
      i(u.target.value), r.onChange && r.onChange(u);
    }
    function c() {
      i(""), r.onChange && r.onChange({
        target: { value: "" }
      }), s(r.name, ""), e?.();
    }
    return /* @__PURE__ */ _(
      Jt,
      {
        ...r,
        ref: n,
        value: a,
        InputProps: {
          ...r.InputProps,
          endAdornment: a ? /* @__PURE__ */ _(Nr, { position: "end", className: "absolute right-5", children: /* @__PURE__ */ _(It, { edge: "end", tabIndex: -1, onClick: c, children: /* @__PURE__ */ _(As, {}) }) }) : null
        },
        onChange: o
      }
    );
  }
);
Zs.displayName = "Input";
const Ds = ie(
  ({ field: t, type: e, label: r, value: n, isSelected: s, onChangeAnalyticsCallback: a }, i) => {
    const { t: o } = Ce(), { register: c } = ut(), u = c(t);
    return /* @__PURE__ */ V("label", { ref: i, className: "flex items-center mb-0", tabIndex: 0, children: [
      /* @__PURE__ */ _(
        "input",
        {
          type: e,
          id: `${t}-${n}`,
          value: n,
          ...u,
          onChange: (h) => {
            u.onChange(h), a?.(r, n);
          },
          className: "hidden"
        }
      ),
      /* @__PURE__ */ _(
        "span",
        {
          className: `px-3 py-1.5 md:px-4 md:py-3 border-none rounded-full cursor-pointer ${s ? "bg-[#4D4E58] text-white" : "hover:bg-gray-200 bg-[#F5F5F6]"}`,
          children: o(r)
        }
      )
    ] });
  }
);
Ds.displayName = "OptionInput";
function Ms({ error: t }) {
  const { t: e } = Ce();
  return /* @__PURE__ */ _(Xe, { variant: "caption", color: "error", children: e(t) });
}
function $s() {
  return /* @__PURE__ */ _(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ _(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4.625C7.9269 4.625 4.625 7.9269 4.625 12C4.625 16.0731 7.9269 19.375 12 19.375C16.0731 19.375 19.375 16.0731 19.375 12C19.375 7.9269 16.0731 4.625 12 4.625ZM3.375 12C3.375 7.23654 7.23654 3.375 12 3.375C16.7635 3.375 20.625 7.23654 20.625 12C20.625 16.7635 16.7635 20.625 12 20.625C7.23654 20.625 3.375 16.7635 3.375 12ZM12.0001 6.6608C12.3453 6.6608 12.6251 6.94062 12.6251 7.2858V8.22845C12.6251 8.57363 12.3453 8.85345 12.0001 8.85345C11.6549 8.85345 11.3751 8.57363 11.3751 8.22845V7.2858C11.3751 6.94062 11.6549 6.6608 12.0001 6.6608ZM12.0001 10.4328C12.3453 10.4328 12.6251 10.7126 12.6251 11.0578V16.7138C12.6251 17.0589 12.3453 17.3388 12.0001 17.3388C11.6549 17.3388 11.3751 17.0589 11.3751 16.7138V11.0578C11.3751 10.7126 11.6549 10.4328 12.0001 10.4328Z",
          fill: "#86868B"
        }
      )
    }
  );
}
const re = ie(
  ({
    field: t,
    type: e,
    label: r = "",
    infoText: n,
    withLabel: s = !0,
    withDivider: a = !0,
    withPlaceholder: i = !1,
    children: o
  }, c) => /* @__PURE__ */ V(
    "div",
    {
      ref: c,
      className: "flex flex-col gap-3 transition-all duration-300 ease-in-out",
      children: [
        /* @__PURE__ */ _(
          Qt,
          {
            field: t,
            fieldInfoType: "inline",
            type: e,
            withLabel: s,
            infoText: n,
            label: r,
            withDivider: a,
            withPlaceholder: i
          }
        ),
        o
      ]
    },
    t
  )
);
function Qt({
  field: t,
  label: e,
  withLabel: r,
  withDivider: n,
  withPlaceholder: s,
  fieldInfoType: a,
  type: i,
  infoText: o
}) {
  const { t: c } = Ce();
  return r ? /* @__PURE__ */ V("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ _(
      Ar,
      {
        htmlFor: t,
        className: "text-base md:text-md font-semibold text-gray-700 mb-0",
        children: e ? c(e) : null
      }
    ),
    i === "multiValue" ? /* @__PURE__ */ _(Xe, { variant: "caption", className: "text-gray-500", children: `(${c("Select all that apply")})` }) : null,
    a === "inline" && o ? /* @__PURE__ */ _(Xe, { variant: "caption", className: "text-gray-500", children: `(${c(o)})` }) : null,
    a === "tooltip" && o ? /* @__PURE__ */ _(
      Ts,
      {
        title: c(o),
        PopperProps: Ls,
        placement: "right-end",
        className: "p-0 hidden md:block",
        children: /* @__PURE__ */ _(It, { children: /* @__PURE__ */ _($s, {}) })
      }
    ) : null
  ] }) : n ? /* @__PURE__ */ _(Zr, {}) : s ? /* @__PURE__ */ _("div", { style: { height: "32px" } }) : null;
}
const Ls = {
  sx: {
    zIndex: 999999943
  }
};
re.displayName = "FormField";
const Us = "singleValue", Vs = "singleValue", Bs = "singleValue", zs = ie(
  ({ fieldRefs: t, index: e, cityComponent: r, stateComponent: n, countryComponent: s }, a) => {
    const { t: i } = Ce();
    return /* @__PURE__ */ V(
      "div",
      {
        ref: (o) => {
          t.current[e] = o, typeof a == "function" ? a(o) : a && (a.current = o);
        },
        className: "flex flex-col w-full gap-4",
        children: [
          /* @__PURE__ */ V("div", { className: "flex flex-row w-full", children: [
            /* @__PURE__ */ _("div", { className: at ? "w-1/2 pr-2" : "w-full", children: /* @__PURE__ */ _(
              re,
              {
                field: "city",
                label: i("Location"),
                type: Us,
                withLabel: !0,
                children: r
              }
            ) }),
            at ? /* @__PURE__ */ _("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ _(
              re,
              {
                field: "state",
                withLabel: !1,
                withDivider: !1,
                withPlaceholder: !0,
                type: Vs,
                children: n
              }
            ) }) : null
          ] }),
          /* @__PURE__ */ _("div", { className: "w-full", children: /* @__PURE__ */ _(
            re,
            {
              field: "country",
              withLabel: !1,
              withDivider: !1,
              withPlaceholder: !1,
              type: Bs,
              children: s
            }
          ) })
        ]
      }
    );
  }
);
zs.displayName = "Location";
function Fs() {
  const t = ut();
  if (!t?.formState)
    return null;
  const { errors: e } = t.formState, r = e?.dueMonth || e?.dueYear, n = r ? e?.dueMonth?.message || e?.dueYear?.message : null;
  return r && n ? /* @__PURE__ */ _(Ms, { error: n }) : null;
}
const qs = "singleValue", Ks = "singleValue", Ws = ie(
  ({ fieldRefs: t, index: e, monthComponent: r, yearComponent: n, readonly: s = !1 }, a) => {
    const { t: i } = Ce();
    return /* @__PURE__ */ V(
      "div",
      {
        ref: (o) => {
          t.current[e] = o, typeof a == "function" ? a(o) : a && (a.current = o);
        },
        className: "flex flex-col w-full gap-3",
        children: [
          /* @__PURE__ */ _("div", { className: "flex flex-row w-full", children: /* @__PURE__ */ _(
            Qt,
            {
              type: "singleValue",
              label: i("Estimated completion date"),
              infoText: i("Project end date"),
              fieldInfoType: "inline",
              withLabel: !0
            }
          ) }),
          /* @__PURE__ */ V(
            "div",
            {
              className: `flex flex-col gap-1 md:gap-4 relative ${s ? "" : "min-h-[80px] md:min-h-[112px]"}`,
              children: [
                /* @__PURE__ */ V("div", { className: "flex flex-row w-full", children: [
                  /* @__PURE__ */ _("div", { className: "w-1/2 pr-2", children: /* @__PURE__ */ _(
                    re,
                    {
                      field: "dueMonth",
                      type: qs,
                      withLabel: !1,
                      withDivider: !1,
                      children: r
                    }
                  ) }),
                  /* @__PURE__ */ _("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ _(
                    re,
                    {
                      field: "dueYear",
                      type: Ks,
                      withLabel: !1,
                      withDivider: !1,
                      children: n
                    }
                  ) })
                ] }),
                s ? null : /* @__PURE__ */ _(Fs, {})
              ]
            }
          )
        ]
      }
    );
  }
);
Ws.displayName = "Timeline";
const Xt = (/* @__PURE__ */ new Date()).getFullYear();
Xt.toString();
(/* @__PURE__ */ new Date()).getMonth();
Ys();
function Ys() {
  return Array.from({ length: 6 }, (t, e) => {
    const r = (Xt + e).toString();
    return { label: r, value: r };
  });
}
const Hs = {
  AL: "Alabama",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}, Gs = {
  AD: "Andorra",
  AT: "Austria",
  BE: "Belgium",
  BG: "Bulgaria",
  HR: "Croatia",
  CZ: "Czechia",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IE: "Ireland",
  IT: "Italy",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MC: "Monaco",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  SE: "Sweden",
  CH: "Switzerland",
  GB: "United Kingdom",
  IL: "Israel",
  SA: "Saudi Arabia",
  AE: "United Arab Emirates",
  TR: "Turkey",
  KW: "Kuwait",
  QA: "Qatar",
  BH: "Bahrain",
  US: "United States",
  MT: "Malta"
}, Js = {
  CA: "Canada",
  US: "United States"
};
Object.entries(Gs).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(Js).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(Hs).map(([t, e]) => ({
  label: e,
  value: e
}));
function Qs(t, e) {
  return !t || !e ? !1 : t.userRef === e?.customer_id;
}
function Xs() {
  const { customer: t } = Kt();
  function e(n) {
    return n ? ea(n, t?.groupId ?? null) : !1;
  }
  function r(n) {
    return Qs(n, t);
  }
  return { isProjectDataComplete: e, isProjectEditable: r };
}
function ea(t, e) {
  return Rs(
    [],
    e
  ).filter(
    (n) => !Is.includes(
      n
    )
  ).every((n) => {
    const s = Ss[n];
    return !!t[s];
  });
}
function ta(t) {
  const {
    data: e,
    loading: r,
    error: n,
    refetch: s
  } = Yt({
    options: {
      skip: !t
    }
  }), a = ot(() => e?.projects.items.reduce(
    (i, o) => (i[o.externalId] = o, i),
    {}
  ) ?? {}, [e?.projects.items]);
  return { loading: r, projects: a, error: n, refetch: s };
}
const er = it({});
function ra({
  shouldFetch: t = !0,
  children: e
}) {
  const { loading: r, projects: n, error: s, refetch: a } = ta(t), { setCurrentProjectId: i } = Wt(), { isProjectDataComplete: o } = Xs(), c = ot(() => {
    function u(h) {
      const T = n[h];
      if (T) {
        if (!o(T)) {
          Ht({
            projectId: Number(h),
            successCallback: () => {
              i(h);
            }
          });
          return;
        }
        i(h);
      }
    }
    return {
      projects: n,
      projectsLoading: r,
      projectsError: s,
      refetch: a,
      setCurrentProject: u
    };
  }, [
    n,
    r,
    s,
    a,
    o,
    i
  ]);
  return /* @__PURE__ */ _(er.Provider, { value: c, children: e });
}
function va() {
  const t = Rt(er);
  if (!t)
    throw new Error(
      "useProjectsProvider must be used within a ProjectsProvider"
    );
  return t;
}
function _a({ children: t }) {
  return /* @__PURE__ */ _(_s, { children: /* @__PURE__ */ _(ra, { children: t }) });
}
function ba(t) {
  return t.status === H.Archived;
}
const xa = {
  [H.Active]: "#709D53",
  [H.OnHold]: "#D18023",
  [H.Completed]: "#425270",
  [H.Canceled]: "#DE6CAF",
  [H.Archived]: "#CECECE"
};
export {
  _a as ProjectsCustomerProvider,
  ra as ProjectsProvider,
  ws as dispatchSetCurrentProjectId,
  ba as isProjectArchived,
  Qs as isProjectEditable,
  ua as projectCreatedEvent,
  xa as projectStatusColorMap,
  cn as projectsAnalyticsSelectors,
  on as setCurrentProjectIdEvent,
  la as useCreateProjectButtonAnalyticsIdentifier,
  fa as useCreateProjectDialog,
  pa as useCurrentProject,
  Wt as useCurrentProjectId,
  ks as useCurrentProjectIdFromCache,
  ha as useEditProjectDialog,
  ya as useProjectUpdate,
  ma as useProjectsCreatedListener,
  va as useProjectsProvider,
  Yt as useProjectsQueryNoPagination,
  ga as useProjectsUpdatedListener,
  Xs as useValidateProjectData
};
